export const Bio = {
  name: "Hardik Khandal",
  roles: [
    "Full Stack Developer",
    "Software Engineer",
    "Programmer",
    "Block Chain Enthusiast",
  ],
  description:
    "As a final-year student, I am driven by a relentless focus on excellence and an insatiable appetite for learning cutting-edge technologies. My dedication and strong work ethic have been instrumental in my academic pursuits. Eager to apply my skills in real-world scenarios, I am poised to make meaningful contributions to innovative projects and teams.",
  github: "https://github.com/hardikkhandal",
  resume:
    "https://drive.google.com/file/d/1Kp67vCZEz3OURnv1CLhRyoD5bEbQeZen/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/hardik-khandal-75bb67243/",
  insta: "https://www.instagram.com/hardik_khandal/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "NextJs",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "TailWind CSS",
        image:
          "https://imgs.search.brave.com/EKsk4xtJu-qcCLu6v_GJEiJbWXakB9PzJp_snmXg4ak/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9jZG4u/d29ybGR2ZWN0b3Js/b2dvLmNvbS9sb2dv/cy90YWlsd2luZC1j/c3MtMi5zdmc.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://imgs.search.brave.com/tq3hucM-dRx8cLV-5lQQ5Qy22SzDqFN1foHTH9A2ZL8/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9zZWVr/bG9nby5jb20vaW1h/Z2VzL04vbm9kZWpz/LWxvZ28tRkJFMTIy/RTM3Ny1zZWVrbG9n/by5jb20ucG5n",
      },
      {
        name: "SpringBoot",
        image:
          "https://www.yessinfotech.com/wp-content/uploads/2019/11/spring-boot-logo.png",
      },

      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Programming Languages",
    skills: [
      {
        name: "Java",
        image:
          "https://imgs.search.brave.com/MEHb9oKvt16NH0J9vog7f2HhP3ktOgPA3xMIsoRV3lc/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9sb2dv/cy1kb3dubG9hZC5j/b20vd3AtY29udGVu/dC91cGxvYWRzLzIw/MTYvMTAvSmF2YV9s/b2dvLTQxNHg3MDAu/cG5n",
      },
      {
        name: "Python",
        image:
          "https://imgs.search.brave.com/sDXS3IWHlItL53Dwu4oDtG8-5ydhvhQW28ByBeYMru8/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9hc3Nl/dHMuc3RpY2twbmcu/Y29tL2ltYWdlcy81/ODQ4MTUyZmNlZjEw/MTRjMGI1ZTQ5Njcu/cG5n",
      },
      {
        name: "C++",
        image:
          "https://imgs.search.brave.com/229mFknfyaJY7GQcGJ0EYV3jBKICdVZEPzx8aIMMbMI/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9icmFu/ZHNsb2dvcy5jb20v/d3AtY29udGVudC91/cGxvYWRzL2ltYWdl/cy9jLWxvZ28ucG5n",
      },
      {
        name: "JavaScript",
        image:
          "https://imgs.search.brave.com/GOFX0wl77eigQ_KgvcJaFqo4gZYXCVV1DsqB4A-Awrk/rs:fit:500:0:0/g:ce/aHR0cHM6Ly9icmFu/ZHNsb2dvcy5jb20v/d3AtY29udGVudC91/cGxvYWRzL2ltYWdl/cy9qYXZhc2NyaXB0/LWxvZ28ucG5n",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "WordPress",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Search Engine Optimization",
        image:
          "https://img.freepik.com/premium-vector/seo-search-engine-optimization-minimal-flat-logo-vector-seo-logo-with-magnifying-glass-arrow_664675-1298.jpg",
      },

      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "MatLab",
        image:
          "https://imgs.search.brave.com/XRTFweZuFCummbCq7UdDNAluY0jqwvz3l1SfB4MODuU/rs:fit:500:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy8y/LzIxL01hdGxhYl9M/b2dvLnBuZw",
      },
      {
        name: "Cisco Packet Tracer",
        image:
          "https://imgs.search.brave.com/WkcmL6mPENwLMjaawsf4XPexPNXZMBfb-hrfbF_coaE/rs:fit:860:0:0/g:ce/aHR0cHM6Ly93d3cu/ZnJlZXBuZ2xvZ29z/LmNvbS91cGxvYWRz/L2Npc2NvLXBuZy1s/b2dvL25ldHdvcmtp/bmctYW5kLWNpc2Nv/LXBhY2tldC10cmFj/ZXItcG5nLWxvZ28t/MTcucG5n",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image: "https://www.svgrepo.com/show/354202/postman-icon.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://digitalbrew.net/wp-content/uploads/2023/01/Group-112.png",
    role: "Web Developer",
    company: "DigitalBrew",
    date: "November 2023 - January 2024",
    desc: "During my time at DigitalBrew, I actively engaged in diverse projects that challenged and expanded my understanding of software development. Collaborating with seasoned professionals, I contributed to the development of innovative solutions while leveraging cutting-edge technologies.Throughout the internship, I embraced a dynamic learning environment, eagerly diving into new technologies and methodologies. ",
    skills: [
      "Search Engine Optimization(SEO)",
      " WordPress",
      "Google Search Console",
      "Google Analytics",
      "Elementor",
      "Elementor",
      "PHP",
      "XML",
      "HTML",
      "CSS",
      "JavaScript",
    ],
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "https://imgs.search.brave.com/Ad1pC9ulSBMvamopSQc1MiZmwEZe32s6I8pheXAeRzY/rs:fit:500:0:0/g:ce/aHR0cHM6Ly92aXQu/YWMuaW4vdml0LXJh/bmsvYXNzZXRzL2lt/Zy9WSVQtbG9nby5w/bmc",
    school: "Vellore Institute of Technology, Vellore",
    date: "Jun 2021 - Sep 2025",
    grade: "8.65* CGPA",
    desc: "I have completed 5 semesters in my pursuit of a Bachelor's degree in Information Technology, maintaining a CGPA of 8.77. Among various clubs like the International Society of Automation and Mozilla Firefox Club, I am a member, engaging in exciting projects with a team of talented developers. The courses I've undertaken include Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, to name a few.",
    degree: "Bachelor of Technology - BTech, Information Technology",
  },
  {
    id: 1,
    img: "https://imgs.search.brave.com/Vxbpg4BLk_o4TjSWSivy_tJ3nVIIOpENk__CceRS4Ig/rs:fit:860:0:0/g:ce/aHR0cHM6Ly93d3cu/am9vbnNxdWFyZS5j/b20vdXNlcm1hbmFn/ZS9pbWFnZS9idXNp/bmVzcy9kZWxoaS1w/dWJsaWMtc2Nob29s/LWphaXB1ci05MTMv/ZGVsaGktcHVibGlj/LXNjaG9vbC1qYWlw/dXItbG9nby5qcGc",
    school: "Delhi Public School, Jaipur",
    date: "Apr 2019 - Apr 2025",
    grade: "95.6%",
    desc: "I successfully completed my high school education at Delhi Public School, Jaipur, achieving the distinction of being the top performer in the subject of Physics.",
    degree: "CBSE (XII)",
  },
  {
    id: 2,
    img: "https://imgs.search.brave.com/Vxbpg4BLk_o4TjSWSivy_tJ3nVIIOpENk__CceRS4Ig/rs:fit:860:0:0/g:ce/aHR0cHM6Ly93d3cu/am9vbnNxdWFyZS5j/b20vdXNlcm1hbmFn/ZS9pbWFnZS9idXNp/bmVzcy9kZWxoaS1w/dWJsaWMtc2Nob29s/LWphaXB1ci05MTMv/ZGVsaGktcHVibGlj/LXNjaG9vbC1qYWlw/dXItbG9nby5qcGc",
    school: "Delhi Public School, Jaipur",
    date: "Apr 2017 - Apr 2019",
    grade: "92.4%",
    desc: "I completed my class 10 education at Delhi Public School, Jaipur",
    degree: "CBSE (X)",
  },
];

export const projects = [
  {
    id: 12,
    title: "NodeNet-AI",
    date: "August 2024 - September 2024",
    description:
      "A distributed LLM hosting system utilizing a black-box model for proximity-based edge node management and security. Built with Java, Spring Boot, Next.js, and Docker. Features multithreaded heartbeat monitoring for real-time node health checks and seamless failover to nearby nodes. Integrates Groq API for edge-based LLM processing and a token-based system for secure inter-node data exchanges. Next.js frontend with Google OAuth2 authentication allows prompt submissions and node interactions.",
    image:
      "https://github.com/hardikkhandal/DecentralizationLLMs/blob/master/Screenshot%20(95).png?raw=true",
    tags: [
      "Java",
      "Spring Boot",
      "Multithreading",
      "Edge Computing",
      "Next.js",
      "Docker",
      "Groq API",
      "OAuth2",
      "Distributed AI",
    ],
    category: "distributed AI",
    github: "https://github.com/hardikkhandal/DecentralizationLLMs",
    webapp: "https://node-net-ai.vercel.app",
  },
  {
    id: 14,
    title: "YoutubeSumify",
    date: "June 2024 - July 2024",
    description:
      "Google Chrome extension that summarizes Youtube videos live Q&A functionality using LLMs ",
    image:
      "https://lh3.googleusercontent.com/VirzUrYPYBHF-6VHj3VE0otE9MAwIMOxWV7SX8vpDS90SxAhRZZZAQ82l0ekH1GLp50gaBEbNYYgiK43f68RUm7NMzQ=s1600-w1600-h1000",
    tags: ["HTML", "CSS", "JAVASCRIPT", "LLM", "Groq", "Node.JS"],
    category: "web app",
    github:
      "https://github.com/hardikkhandal/nodejs-serverless-function-express",
    webapp:
      "https://github.com/hardikkhandal/nodejs-serverless-function-express",
  },
  {
    id: 13,
    title: "SkinCare.ai",
    date: "January 2023 - May 2023",
    description:
      "An AI-powered web application for preliminary diagnosis of skin diseases. Built using Next.js, Express.js, and MongoDB. Features NextAuth.js authentication, Stripe payments integration, and a ChatBase-powered chatbot for Q&A. Developed as part of a collaborative effort at SIH 2023.",
    image:
      "https://github.com/hardikkhandal/skincare/blob/main/Screenshot%20(96).png?raw=true",
    tags: [
      "Next.js",
      "Express.js",
      "MongoDB",
      "ChatBase",
      "Stripe",
      "NextAuth.js",
      "AI",
      "Healthcare Tech",
    ],
    category: "AI healthcare",
    github: "https://github.com/hardikkhandal/skincare",
    webapp: "https://sih-neural-nexus.vercel.app/",
  },
  {
    id: 10,
    title: "YelpCamp",
    date: "September 2023 - October 2023",
    description:
      "Dynamic camping platform allowing users to explore and share unique camping experiences. HTML, CSS, JavaScript, Node.js, Express.js, MongoDB, Passport.js, EJS, and Express-session. User-friendly interfaces, secure authentication, and seamless data management with effective error handling",
    image:
      "https://github.com/hardikkhandal/YelpCamp/blob/main/Screenshot%20(24).png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "BOOTSTRAP",
      "JAVASCRIPT",
      "ExpressJS",
      "MongoDB",
      "Passport.js",
      "EJS",
      "Express-session",
    ],
    category: "web app",
    github: "https://github.com/hardikkhandal/YelpCamp",
    webapp: "https://github.com/hardikkhandal/YelpCamp",
  },
  {
    id: 0,
    title: "CythiaUgwu",
    date: "Jun 2023 - Jul 2023",
    description:
      "Crafted a compelling frontend website replica of Designer Cynthia Ugwu utilizing a blend of advanced technologies including HTML, CSS, and JavaScript, enhanced with potent libraries such as GSAP for captivating animations, showcasing proficiency in web development.",
    image:
      "https://github.com/hardikkhandal/CythiaUgwu/blob/main/Screenshot%20(17).png?raw=true",
    tags: ["HTML", "CSS", "BOOTSTRAP", "JAVASCRIPT", "GSAP"],
    category: "web app",
    github: "https://github.com/hardikkhandal/CythiaUgwu",
    webapp: "https://hardikkhandal.github.io/CythiaUgwu/",
  },
  {
    id: 1,
    title: "Clothes-Inventory-System",
    date: "Feb 2023 - Mar 2023",
    description:
      "Designed and developed a comprehensive Clothes Inventory System utilizing Next.js for the frontend and MongoDB for the backend, demonstrating proficiency in full-stack web development and database management.",
    image:
      "https://github.com/hardikkhandal/Clothes-Inventory-System/blob/main/Screenshot%20(18).png?raw=true",
    tags: ["NEXTJS", "MONGODB"],
    category: "web app",
    github: "https://github.com/hardikkhandal/Clothes-Inventory-System",
    webapp: "https://github.com/hardikkhandal/Clothes-Inventory-System",
  },

  {
    id: 11,
    title: "Animated Landing Page",
    date: "October 2023 - October 2023",
    description:
      "Introducing an Astonishing Landing Page Crafted with Pure HTML, CSS, JavaScript, and Powered by the Dynamic Duo: Shery.js and GSAP! With Shery.js and GSAP, We've Taken Web Development to a Whole New Level! Don't Miss Out!",
    image:
      "https://github.com/hardikkhandal/LandingPage/blob/main/Screenshot%20(25).png?raw=true",
    tags: ["HTML", "CSS", "JAVASCRIPT", "ANIMATION", "GSAP", "SHERY.JS"],
    category: "web app",
    github: "https://github.com/hardikkhandal/LandingPage",
    webapp: "https://landing-page-six-woad.vercel.app/",
  },

  {
    id: 15,
    title: "Scatch",
    date: "January 2024 - March 2024",
    description:
      "Dynamic e-commerce platform with real-time admin support, admin dashboard.",
    image:
      "https://www.google.com/url?sa=i&url=https%3A%2F%2Fpngtree.com%2Fso%2Fecommerce-logo&psig=AOvVaw3sFhlA2sR05TYipTnMA9hV&ust=1724766258698000&source=images&cd=vfe&opi=89978449&ved=0CBQQjRxqFwoTCOiV1pLlkogDFQAAAAAdAAAAABAE",
    tags: [
      "HTML",
      "CSS",
      "JAVASCRIPT",
      "Stripe",
      "MongoDB",
      "Node.JS",
      "TailWind CSS",
      "JWT",
      "EJS",
      "GSAP",
    ],
    category: "web app",
    github: "https://github.com/hardikkhandal/Scatch2.0",
    webapp: "https://github.com/hardikkhandal/Scatch2.0",
  },
  {
    id: 4,
    title: "SmartAgricultureIOT",
    date: "Nov 2022 - Dec 2023",
    description:
      "Engineered an embedded Internet of Things (IoT) project employing NODEMCU and Arduino microcontrollers, incorporating serial port communication for seamless integration with ThingESP and ThingSpeak platforms. Implemented a novel control mechanism via WhatsApp, enabling remote sensor manipulation through command-based interactions. This project showcases advanced proficiency in IoT device development, firmware programming, and cloud integration.",
    image:
      "https://github.com/hardikkhandal/SmartAgricultureIOT/blob/main/Screenshot%20(5).png?raw=true",
    tags: ["Arduino", "NodeMCU", "IOT", "ThingESP", "ThinkSpeak"],
    category: "IOT",
    github: "https://github.com/hardikkhandal/SmartAgricultureIOT/",
    webapp: "https://github.com/hardikkhandal/SmartAgricultureIOT/",
  },
  {
    id: 5,
    title: "Todo List",
    date: "September 2023 - September-2023",
    description:
      "I have developed a ToDo list application using the React framework in conjunction with Next.js version 13. Additionally, I utilized the Tailwind CSS utility-first framework for styling and implemented the application's functionality using JavaScript.",
    image:
      "https://github.com/hardikkhandal/ToDoList/blob/main/Screenshot%20(23).png?raw=true",
    tags: ["ReactJS", "Next13", "TailWind CSS"],
    category: "web app",
    github: "https://github.com/hardikkhandal/ToDoList",
    webapp: "https://hardikkhandal.github.io/ToDoList/",
  },
  {
    id: 2,
    title: "TicTacToe",
    date: "Jan 2023 - Jan 2023",
    description:
      "Engineered a Tic Tac Toe web application leveraging HTML for structuring and CSS for stylization and JAVASCRIPT for logical building showcasing proficiency in front-end web development by creating an interactive and engaging user experience",
    image:
      "https://github.com/hardikkhandal/TicTacToe/blob/main/Screenshot%20(19).png?raw=true",
    tags: ["HTML", "CSS", "JAVASCRIPT"],
    category: "web app",
    github: "https://github.com/hardikkhandal/TicTacToe/tree/main",
    webapp: "https://hardikkhandal.github.io/TicTacToe/",
  },
  {
    id: 3,
    title: "BubbleGame",
    date: "Jan 2023 - Jan 2023",
    description:
      "Designed and developed an engaging Bubble Game utilizing HTML and CSS, demonstrating expertise in front-end web development and user interface design. The project showcases a seamless and interactive gaming experience, highlighting proficiency in crafting visually appealing and responsive web applications",
    image:
      "https://github.com/hardikkhandal/BubbleGame/blob/main/Screenshot%20(20).png?raw=true",
    tags: ["HTML", "CSS", "JAVASCRIPT"],
    category: "web app",
    github: "https://github.com/hardikkhandal/BubbleGame",
    webapp: "https://hardikkhandal.github.io/BubbleGame/",
  },
];
